import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { toast } from 'sonner';
import { api } from '../../services/api';

export const AlertModal = ({ showAlertModal, setShowAlertModal, alertForm, setAlertForm, fetchData, formatCurrency }) => (
  <Dialog open={!!showAlertModal} onOpenChange={() => setShowAlertModal(null)}>
    <DialogContent className="bg-[#0A0A0A] border-[#262626] max-w-md" data-testid="alert-modal">
      <DialogHeader><DialogTitle className="font-serif text-white">Set Price Alert</DialogTitle></DialogHeader>
      {showAlertModal && (
        <div className="space-y-4">
          <div className="p-3 bg-[#0F0F0F] border border-[#1A1A1A] rounded">
            <p className="text-white text-sm font-medium">{showAlertModal.asset_name}</p>
            <p className="text-[11px] text-muted-foreground">Currently {formatCurrency(showAlertModal.price_per_fraction)} / fraction</p>
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider text-muted-foreground">Notify me when price reaches (£)</label>
            <Input type="number" step="0.01" min="0.01" value={alertForm.target} onChange={e => setAlertForm({ target: e.target.value })} className="luxury-input mt-1" data-testid="alert-target-input" />
          </div>
          <p className="text-[10px] text-muted-foreground italic">You'll be notified in-app the moment the price drops to this level or lower.</p>
          <Button data-testid="submit-alert-btn" onClick={async () => {
            const target = parseFloat(alertForm.target);
            if (!target || target <= 0) { toast.error('Enter a valid target price'); return; }
            try {
              await api.createFractionAlert({ token_id: showAlertModal.id, target_price: target });
              toast.success('Price alert set.');
              setShowAlertModal(null);
              fetchData();
            } catch (e) { toast.error(e.response?.data?.detail || 'Failed to set alert'); }
          }} className="w-full bg-[#627EEA] hover:bg-[#5570D0] text-white">
            Save Alert
          </Button>
        </div>
      )}
    </DialogContent>
  </Dialog>
);
